import { Loader as LucidLoader } from "lucide-react";
import React from "react";

interface LoaderProps {
  size?: number;
}

const Loader = ({ size }: LoaderProps) => {
  return <LucidLoader size={size} className="animate-spin dark:text-white" />;
};

export default React.memo(Loader);
